import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M10.472 11.287a2.75 2.75 0 1 0 3.056-4.573 2.75 2.75 0 0 0-3.056 4.573m.834-3.326a1.25 1.25 0 1 1 1.389 2.079 1.25 1.25 0 0 1-1.39-2.08",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M5.25 8.83c0 1.883.972 3.794 2.152 5.42H6.44a2.76 2.76 0 0 0-2.61 1.88l-.66 2a2.71 2.71 0 0 0 .37 2.48 2.75 2.75 0 0 0 2.24 1.14h12.45a2.75 2.75 0 0 0 2.72-2.335 2.7 2.7 0 0 0-.12-1.285l-.66-2a2.76 2.76 0 0 0-2.61-1.88h-.954c1.176-1.626 2.144-3.537 2.144-5.42A6.67 6.67 0 0 0 12 2.25a6.67 6.67 0 0 0-6.75 6.58M12 18.75a.8.8 0 0 1-.47-.16l-.03-.026a26 26 0 0 1-2.894-2.814H6.44a1.26 1.26 0 0 0-1.19.85l-.66 2a1.23 1.23 0 0 0 .17 1.13 1.25 1.25 0 0 0 1 .52h12.47a1.25 1.25 0 0 0 1.18-1.65l-.67-2a1.24 1.24 0 0 0-1.18-.85h-2.154c-1.43 1.632-2.805 2.742-2.936 2.84a.8.8 0 0 1-.47.16M6.75 8.83c0 1.883 1.278 3.91 2.626 5.521a.75.75 0 0 1 .323.376A25 25 0 0 0 12 17.02c1.37-1.21 5.25-4.91 5.25-8.19A5.18 5.18 0 0 0 12 3.75a5.18 5.18 0 0 0-5.25 5.08",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }